export default __webpack_public_path__ + "static/Entenda0139-136697e4451154beacc1441e7151e159.jpg";